<div class="employee-details-view-container"  fxLayout="column" fxLayoutGap="15px" *ngIf="currentLeave"  >

  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async)?.human_resources.admin_root " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>

    <button
      [disabled]="!(userPermissions | async)?.human_resources.admin_root "
      mat-stroked-button (click)="addLeaveApplication()"
    ><mat-icon>add</mat-icon><span> Dodaj wniosek</span></button>

    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>edit</span></button>

  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card  *ngIf="user && employee">
            <div fxLayout="row">
              <h3>Dane pracownika</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Imię" [value]="user.firstName"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Nazwisko" [value]="user.lastName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Numer telefonu" [value]="user.phone | phone"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Adres email" [value]="user.email"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Dział" [value]="user.department?.name"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Przełożony" [value]="user.department?.supervisorFullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Stanowisko" [value]="user.position"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Data zatrudnienia od" [value]="employee.employmentAt | date:'y-MM-dd'"></app-detail>
              </div>
              <div fxFlex="100">
                <app-detail header="Data zatrudnienia do" [value]="employee.employmentTo | date:'y-MM-dd'"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Wymiar etatu " [value]="employee.workingHours?.name"></app-detail>
              </div>

            </div>

          </mat-card>
        </div>
      </div>
    </div>


    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card *ngIf="currentLeave">
            <div fxLayout="row">
              <h3>Dane urlopu bieżące</h3>
            </div>

            <div fxLayout="row">
              <h3>{{ currentLeave.year }}</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych do wykorzystania" [value]=" currentLeave.halfTimeInUse ? (((currentLeave.overdueLeave +  currentLeave.dayToUse) - currentLeave.dayOfUse ) + 0.5 + (currentLeave.halfTimeOverdueLeave && !currentLeave.halfTimeOverdueLeaveInUse ? 0.5 : 0 ) ).toString():  ((currentLeave.overdueLeave +  currentLeave.dayToUse) - currentLeave.dayOfUse + (currentLeave.halfTimeOverdueLeave && !currentLeave.halfTimeOverdueLeaveInUse ? 0.5 : 0 ) ).toString()" ></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych wykorzystanych" [value]="currentLeave.halfTimeInUse ? (currentLeave.dayOfUse -  (currentLeave.halfTimeOverdueLeave && currentLeave.halfTimeOverdueLeaveInUse ? 0 :  0.5 )).toString():  (currentLeave.dayOfUse + (currentLeave.halfTimeOverdueLeave && currentLeave.halfTimeOverdueLeaveInUse ? 0.5 : 0 )).toString()"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych opieka na dziecko" [value]="(currentLeave.childcareLeaveUse ).toString() + '/' + currentLeave.childcareLeaveToUse.toString() " ></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych zaległych" [value]="(currentLeave.overdueLeave + (currentLeave.halfTimeOverdueLeave ? 0.5 : 0 )).toString()"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                <app-detail header="Liczba godzin wykorzystanych " [value]="currentLeave.minuteDimension| HHMM"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych 1/2 dnia wykorzystanych" [value]="(currentLeave.halfTimeDay + (currentLeave.halfTimeOverdueLeaveInUse ? 1 : 0 )).toString()"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                <app-detail header="Wymiar urlopu" [value]="currentLeave.dayToUse.toString()"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Liczba dni do odbioru" [value]=" currentLeave.receptionDayOfUse.toString() + '/' + currentLeave.receptionDayToUse.toString()"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card *ngIf="lastLeave">
            <div fxLayout="row">
              <h3>Dane urlopu historyczne</h3>
            </div>

            <div fxLayout="row">
              <h3>{{ lastLeave.year }}</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                <app-detail header="Wymiar urlopu" [value]="lastLeave.dayToUse.toString()"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych zaległych" [value]="lastLeave.overdueLeave.toString()"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych do wykorzystania" [value]="((lastLeave.overdueLeave + lastLeave.dayToUse)-lastLeave.dayOfUse).toString()"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Liczba dni urlopowych wykorzystanych" [value]="lastLeave.dayOfUse.toString()"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>

